import { render, staticRenderFns } from "./HomeHappening.vue?vue&type=template&id=2ef05d66"
import script from "./HomeHappening.vue?vue&type=script&lang=js"
export * from "./HomeHappening.vue?vue&type=script&lang=js"
import style0 from "./HomeHappening.vue?vue&type=style&index=0&id=2ef05d66&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports